export const CALUCLATOR_LINK_BY_LANG_ID = {
  2: '/en/calculator',
  1: '/calculator',
  11: '/cn/calculator',
  7: '/es/calculator',
  default: '/calculator',
};

export const BASKET_LINK_BY_LANG_ID = {
  2: '/en/basket',
  1: '/basket',
  11: '/cn/basket',
  7: '/es/basket',
  default: '/basket',
};
